export default __webpack_public_path__ + "static/hochzeitsfotografin-berlin-brandenburg-bernau-claudia_nuernberger-e0ff2df3d820ea9d452efe8c8e43fd55.jpg";